var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__poligonosvg",domProps:{"innerHTML":_vm._s(_vm.svgPoligono)}})
}
var staticRenderFns = []

export { render, staticRenderFns }